// CONSTANTS
import { ROUTE_BLOG_POST } from '@/constants/routes';

// UTILITY
import getLink from '@/utility/routes';
import { cleanTextFromTags } from '@/utility/common';

export default data => {
  const url = data?.slug ? getLink(ROUTE_BLOG_POST, { slug: data.slug }) : '';
  const headline = data?.excerpt?.rendered ? cleanTextFromTags(data.excerpt.rendered) : '';
  const descriptionItem = data?.yoast_meta?.find(item => item.property === 'og:description');

  return {
    '@type': 'BlogPosting',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    headline,
    name: data?.title?.rendered,
    description: descriptionItem?.content || '',
    inLanguage: 'English',
    url,
    image: data?.x_featured_media_medium,
    thumbnailUrl: data?.x_featured_media_medium,
    datePublished: data?.x_date,
    dateModified: data?.modified,
    author: {
      '@type': 'Person',
      name: data?.x_author,
    },
    genre: data?.x_categories,
    keywords: data?.x_tags,
  };
};
